<template>
    <div class="key-data-sup-quit-audit">
        <div class="title">供应商退出审批</div>
        <QuitInfo v-if="quitInfoVisible" :auditId="auditId" />
        <SupBaseInfo v-if="baseInfoVisible" :supplierParams="supplierParams" />
    </div>
</template>
<script>
import { getSupByAuditId } from '../../../../../../api/keyDataDetail.js'
import QuitInfo from './QuitInfo.vue';
import SupBaseInfo from './SupBaseInfo.vue';
export default {
    components: { QuitInfo, SupBaseInfo },
    props: {
        auditId: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            // 供应商信息参数
            supplierParams: {
                id: '',
                businessType: '',
                supplierCode: '',
                propertyNature: '',
            },
            quitInfoVisible: true,
            baseInfoVisible: false,
        };
    },
    methods: {
        setSupplierParams() {
            getSupByAuditId({ auditId: this.auditId }).then(res => {
                if (res && +res.code === 0) {
                    if (res.data) {
                        this.supplierParams.id = res.data.supplierInfoId
                        this.supplierParams.businessType = res.data.businessType
                        this.supplierParams.supplierCode = res.data.supplierCode
                        this.supplierParams.propertyNature = res.data.propertyNature
                    }
                    this.baseInfoVisible = true
                }
            }).catch(err => {})
        },
    },
    mounted() {
        this.setSupplierParams()
    },
};
</script>
<style lang="less" scoped>
.key-data-sup-quit-audit {
    color: #000;

    .title {
        margin-bottom: 15px;
        font-size: 16px;
        font-weight: bold;
    }
}
</style>
